import { Box } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

interface Props {
  roundTrip: boolean
  calculatedMileage: number
  units: string
}

const MileageAlertCallout = ({ calculatedMileage, roundTrip, units }: Props) => {
  return (
    <Box width="full" paddingTop="s16">
      <Callout
        type="warning"
        title={i18n.t('expenses_v2.forms.fields.mileage.alert.manually_changed.title')}
        description={
          calculatedMileage
            ? i18n.t('expenses_v2.forms.fields.mileage.alert.manually_changed.description', {
                calculated_mileage: calculatedMileage * (roundTrip ? 2 : 1),
                units: units.toLowerCase(),
              })
            : i18n.t(
                'expenses_v2.forms.fields.mileage.alert.manually_changed.description_no_calculated_mileage'
              )
        }
      />
    </Box>
  )
}

export default MileageAlertCallout
